export default {
  async getBaseShapePriceData({ commit, getters, rootState, state }, args) {
    const payload = {
      base_shape: state.baseShapeData.baseShape
    };

    if (args?.productCode) {
      payload.products = getters.productsToAddToShoppingCartPayload;
      const existing = payload.products.find(
        (x) => x.product_code === args.productCode
      );
      if (existing) {
        existing.quantity = args.quantity;
      } else {
        payload.products.push({
          product_code: args.productCode,
          quantity: args.quantity
        });
      }

      console.log('getBaseShapePriceData', payload);
    }

    const config = {
      params: {
        action: 'baseshape_price',
        culture: rootState.culture
      }
    };
    const { data } = await this._vm.$wiswiseproxyclient.post(payload, config);

    // PBI #117373: intercept wiswise response to keep track of product url
    if (args?.productUrl) {
      for (const product of data.products) {
        product.product_url = args.productUrl;
      }
    }

    commit('setBaseShapePriceData', data);
  }
};
